<div class="screen">

  <!-- ── Hero (même bloc que site-detail) ── -->
  <div class="hero-card" [attr.data-tension]="tensionKey()">
    <span class="hero-badge" [attr.data-tension]="tensionKey()">
      <span class="hero-badge-dot" [attr.data-tension]="tensionKey()"></span>
      {{ tensionLabel() }}
    </span>
    <div class="hero-top">
      <h1 class="hero-name">{{ site.nom }}</h1>
    </div>
  </div>

  <!-- ── Temps d'attente ── -->
  <p class="section-label">{{ 'mobileSimulator.commPatient.waitTimeLabel' | translate }}</p>

  <div class="wait-control">

    <div class="wait-ring-wrap">
      <svg class="wait-ring" viewBox="0 0 160 160" preserveAspectRatio="xMidYMid meet">
        <defs>
          <linearGradient id="wg" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" [attr.stop-color]="waitRingColor()" stop-opacity="0.6"></stop>
            <stop offset="100%" [attr.stop-color]="waitRingColor()"></stop>
          </linearGradient>
        </defs>
        <circle cx="80" cy="80" r="60" [attr.stroke]="waitTrackColor()" stroke-width="12" fill="none"></circle>
        <circle class="wait-ring-progress" cx="80" cy="80" r="60" stroke-width="12" stroke="url(#wg)"
          fill="none" pathLength="100" stroke-dasharray="100" [attr.stroke-dashoffset]="waitDashOffset()"
          stroke-linecap="round"></circle>
        <circle cx="80" cy="80" r="47" fill="#FFFFFF"></circle>
      </svg>
      <div class="wait-ring-center">
        <div class="wait-minutes" [style.color]="waitMinutesColor()">{{ waitMinutes() }}</div>
        <div class="wait-unit">min</div>
      </div>
    </div>

    <div class="wait-slider-row">
      <button class="wait-step-btn" (click)="adjustWait(-5)">−</button>
      <input class="wait-slider" type="range" min="0" max="90" step="1"
        [value]="waitMinutes()" (input)="setWait($event)" />
      <button class="wait-step-btn" (click)="adjustWait(5)">+</button>
    </div>

    @if (waitSaved()) {
      <div class="confirm-toast">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        <span>{{ 'mobileSimulator.commPatient.waitUpdated' | translate }}</span>
      </div>
    }

    <button class="save-wait-btn" (click)="saveWait()">{{ 'mobileSimulator.commPatient.validateButton' | translate: { minutes: waitMinutes() } }}</button>

  </div>

  <!-- ── Message affiché ── -->
  <p class="section-label">{{ 'mobileSimulator.commPatient.messageLabel' | translate }}</p>

  <div class="message-control">
    <textarea class="message-textarea" [(ngModel)]="currentMessage" rows="4"
      [placeholder]="'mobileSimulator.commPatient.messagePlaceholder' | translate"></textarea>

    @if (sent()) {
      <div class="confirm-toast">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        <span>{{ 'mobileSimulator.commPatient.messageUpdated' | translate }}</span>
      </div>
    }

    <button class="send-btn" (click)="send()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
      </svg>
      {{ 'mobileSimulator.commPatient.updateMessageButton' | translate }}
    </button>
  </div>

</div>